import { format } from "date-fns";
import { formatUniversalNumber } from "../../../lib/utils";
export const forReviewColumns = () => {
  return [
    {
      id: "select",
      header: ({ table }: any) => (
        <input
          id="checkbox-all"
          type="checkbox"
          checked={table.getIsAllRowsSelected()}
          onChange={table.getToggleAllRowsSelectedHandler()}
        />
      ),
      size: 30,
      minSize: 30,
      maxSize: 30,
      cell: ({ row }: any) => (
        <input
          id={`checkbox-${row.id}`}
          type="checkbox"
          checked={row.getIsSelected()}
          onChange={row.getToggleSelectedHandler()}
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "transactionDate",
      header: "DATE",
      cell: ({ row }: any) => (
        <>
          {format(new Date(row.original.transactionDate), "MM/dd/yyyy") || "-"}
        </>
      ),
    },
    {
      accessorKey: "personalFinanceCategoryDetailed",
      header: "DESCRIPTION",
      cell: ({ row }: any) => (
        <span>
          {row.original.personalFinanceCategoryDetailed?.trim() || "-"}
        </span>
      ),
    },
    {
      accessorKey: "merchantName",
      header: "FROM/TO",
      cell: ({ row }: any) => (
        <span>{row.original.merchantName?.trim() || "-"}</span>
      ),
    },
    {
      accessorKey: "amount",
      header: "AMOUNT",
      cell: ({ row }: any) => formatUniversalNumber(row.original.amount),
    },

    {
      accessorKey: "recordTypeName",
      header: "STATUS",
      cell: ({ row }: any) => {
        const status =
          row.original.recordTypeName === "To be Review" ? "paid" : "active";

        const badgeStyles: { [key: string]: string } = {
          active: "bg-[#ECFDF3] text-[#027A48]",
          paid: "bg-[#FEF2F1] text-[#B42318]",
        };

        return (
          <span
            className={`BookEZ_font_body_size BookEZ_font_body_medium px-3 py-1 w-auto rounded-[4px] ${badgeStyles[status]}`}
          >
            {row?.original?.recordTypeName}
          </span>
        );
      },
    },
  ];
};

export const categorizedColumns = () => {
  return [
    {
      accessorKey: "transactionDate",
      header: "DATE",
      cell: ({ row }: any) => {
        const date = row.original.transactionDate;
        return date ? <>{format(new Date(date), "MM/dd/yyyy")}</> : <>-</>;
      },
    },
    {
      accessorKey: "transactionName",
      header: "DESCRIPTION",
      cell: ({ row }: any) => (
        <span>{row.original.transactionName?.trim() || "-"}</span>
      ),
    },
    {
      accessorKey: "amount",
      header: "AMOUNT",
      cell: ({ row }: any) => {
        const amount = row.original.amount;
        return formatUniversalNumber(amount) || "-";
      },
    },
    {
      accessorKey: "merchantName",
      header: "FROM/TO",
      cell: ({ row }: any) => (
        <span>{row.original.merchantName?.trim() || "-"}</span>
      ),
    },
  ];
};

export const exludedColumns = () => {
  return [
    {
      accessorKey: "transactionDate",
      header: "DATE",
      cell: ({ row }: any) => {
        const date = row.original.transactionDate;
        return date ? <>{format(new Date(date), "MM/dd/yyyy")}</> : <>-</>;
      },
    },
    {
      accessorKey: "transactionName",
      header: "DESCRIPTION",
      cell: ({ row }: any) => (
        <span>{row.original.transactionName?.trim() || "-"}</span>
      ),
    },
    {
      accessorKey: "amount",
      header: "AMOUNT",
      cell: ({ row }: any) => formatUniversalNumber(row.original.amount) || "-",
    },
  ];
};
